import { useRef, useEffect, useState } from 'react'
import { useThemeMode } from '_metronic/partials'
import ApexCharts, { ApexOptions } from 'apexcharts'
// import moment from 'moment'
// import 'moment-timezone'
import { extractAreaChart } from 'Utils/ApexChartsTooltipsExtractration'
import formatNumberCommas from 'Utils/formatNumberCommas'

const ViewModel = () => {
	const chartRef = useRef<HTMLDivElement | null>(null)
	const { mode } = useThemeMode()
	const [currentDataType, setCurrentDataType] = useState<
		'today' | 'thisweek' | 'thismonth' | 'bought'
	>('today')

	const getChartOptions = (): ApexOptions => {
		const data = [100, 200, 300, 400, 500, 600, 700, 800]
		const months = [
			'2023-08',
			'2023-09',
			'2023-10',
			'2023-11',
			'2023-12',
			'2024-01',
			'2024-02',
			'2024-03',
		]

		return {
			subtitle: {
				text: 'ยอดขาย',
				margin: 0,
				style: {
					fontSize: '18px',
					fontWeight: 'bold',
					fontFamily: 'Noto Sans Thai, sans-serif',
				},
			},
			colors: ['#7F56D9'],
			series: [
				{
					name: 'Sales',
					data: data,
				},
			],
			chart: {
				height: 350,
				type: 'area',
				zoom: {
					enabled: false,
				},
				toolbar: {
					show: false,
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				curve: 'smooth',
				lineCap: 'square',
			},
			grid: {
				row: {
					colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
					opacity: 0.5,
				},
				padding: {
					top: 55,
				},
			},
			xaxis: {
				categories: months,
			},
			tooltip: {
				custom: function ({ dataPointIndex, w, seriesIndex }) {
					const datas = w.globals.initialSeries
					const dataColor = w.globals.colors

					const extractedData = extractAreaChart(datas, dataColor, dataPointIndex, seriesIndex)

					return `<div class="fw-medium">฿ ${formatNumberCommas(extractedData.value)}</div>`
				},
			},
		}
	}

	const refreshChart = () => {
		if (!chartRef.current) {
			return
		}

		const chart = new ApexCharts(chartRef.current, getChartOptions())
		if (chart) {
			chart.render()
		}

		return chart
	}

	useEffect(() => {
		const chart = refreshChart()

		return () => {
			if (chart) {
				chart.destroy()
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [chartRef, mode])

	return {
		chartRef,
		currentDataType,
		setCurrentDataType,
	}
}

export default ViewModel
